module.exports = __webpack_public_path__ + "media/cases-brand-maxam-lazyload-141.07c1ddae.mp4";